// Reveal-on-scroll for Lettoria sections: descendants marked `.reveal` fade and
// rise in once as they enter the viewport. The hidden initial state only
// applies after this element arms itself, so content stays visible without JS
// (SEO / no-JS fallback). Skips animation under prefers-reduced-motion.
class LettoriaReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    this.classList.add('reveal-armed');
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.12 }
    );
    for (const el of this.querySelectorAll('.reveal')) io.observe(el);
  }
}

if (!customElements.get('lettoria-reveal')) {
  customElements.define('lettoria-reveal', LettoriaReveal);
}
